export const AVAILABLE_STATES_FULL = [
  { id: "All", title: "All" },
  { id: "Alaska", title: "AK" },
  { id: "Alabama", title: "AL" },
  { id: "Arkansas", title: "AR" },
  { id: "Arizona", title: "AZ" },
  { id: "California", title: "CA" },
  { id: "Colorado", title: "CO" },
  { id: "Connecticut", title: "CT" },
  { id: "Delaware", title: "DE" },
  { id: "District of Columbia", title: "DC" },
  { id: "Florida", title: "FL" },
  { id: "Georgia", title: "GA" },
  { id: "Hawaii", title: "HI" },
  { id: "Iowa", title: "IA" },
  { id: "Idaho", title: "ID" },
  { id: "Illinois", title: "IL" },
  { id: "Indiana", title: "IN" },
  { id: "Kansas", title: "KS" },
  { id: "Kentucky", title: "KY" },
  { id: "Louisiana", title: "LA" },
  { id: "Massachusetts", title: "MA" },
  { id: "Maryland", title: "MD" },
  { id: "Maine", title: "ME" },
  { id: "Michigan", title: "MI" },
  { id: "Minnesota", title: "MN" },
  { id: "Missouri", title: "MO" },
  { id: "Mississippi", title: "MS" },
  { id: "Montana", title: "MT" },
  { id: "North Carolina", title: "NC" },
  { id: "North Dakota", title: "ND" },
  { id: "Nebraska", title: "NE" },
  { id: "New Hampshire", title: "NH" },
  { id: "New Jersey", title: "NJ" },
  { id: "New Mexico", title: "NM" },
  { id: "Nevada", title: "NV" },
  { id: "New York", title: "NY" },
  { id: "Ohio", title: "OH" },
  { id: "Oklahoma", title: "OK" },
  { id: "Oregon", title: "OR" },
  { id: "Pennsylvania", title: "PA" },
  { id: "Rhode Island", title: "RI" },
  { id: "South Carolina", title: "SC" },
  { id: "South Dakota", title: "SD" },
  { id: "Tennessee", title: "TN" },
  { id: "Texas", title: "TX" },
  { id: "Utah", title: "UT" },
  { id: "Virginia", title: "VA" },
  { id: "Vermont", title: "VT" },
  { id: "Washington", title: "WA" },
  { id: "Wisconsin", title: "WI" },
  { id: "West Virginia", title: "WV" },
  { id: "Wyoming", title: "WY" }
];
